"use client";

import styles from "./page-searchbar.module.css";
import { useTranslations } from "next-intl";
import { useRef } from "react";
import TypeSelector from "./type/type-selector";
import PurposeSelector from "./purpose/purpose-selector";
import { useMyListingsStore } from "../../useMyListingsStore";

export default function PageSearchbar({
  locale,
  sessionId,
}: {
  locale: string;
  sessionId: string | null;
}) {
  const t = useTranslations("PagesSearchbars");

  const type = useMyListingsStore((state) => state.type);
  const purpose = useMyListingsStore((state) => state.purpose);
  const text = useMyListingsStore((state) => state.text);
  const onTextChange = useMyListingsStore((state) => state.onTextChange);
  const refetchState = useMyListingsStore().refetchState;
  const suggestionsWrapperRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div ref={scrollRef} className={styles.searchbarWrapper}>
      <div
        className={`${styles.itemWrapper} ${styles.inputWrapper}`}
        ref={suggestionsWrapperRef}
        onClick={() => inputRef.current?.focus()}
      >
        <div className={styles.textWrapper}>
          <label className={styles.title}>
            {t("savedAndMyListings.searchLabel", { default: "Search" })}
          </label>
          <input
            className={styles.input}
            ref={inputRef}
            type="text"
            value={text}
            placeholder={t("savedAndMyListings.fieldDescription")}
            onChange={(e) => onTextChange(e, locale, sessionId)}
          />
        </div>
      </div>

      <div className={styles.separator}></div>

      <TypeSelector
        t={t}
        type={type}
        refetchState={async () => {
          await refetchState(locale, sessionId);
        }}
      />

      <div className={styles.separator}></div>

      <PurposeSelector
        t={t}
        purpose={purpose}
        refetchState={async () => {
          await refetchState(locale, sessionId);
        }}
      />
    </div>
  );
}
